<template>
  <div class="info-item-details">
    <b-list-group class="autoscroll">
      <template v-for="kv in data">
        <b-list-group-item class="fix-item-height">
          <div class="row">
            <div class="col-6">{{kv.key}}</div>
            <div class="col-6">{{kv.value}}</div>
          </div>
        </b-list-group-item>
      </template>
    </b-list-group>
  </div>
</template>
<script>

  export default {
    name: 'info-tool-details',
    computed: {
      data () {
        let arr = []
        this.$store.getters['map/currentInfoItem'] && Object.keys(this.$store.getters['map/currentInfoItem'])
          .forEach(k => {
            let v = k === 'last_modified_date' && this.$store.getters['map/currentInfoItem'][k] ? new Date(this.$store.getters['map/currentInfoItem'][k]).toLocaleString() : this.$store.getters['map/currentInfoItem'][k]
            arr.push({
              key: k,
              value: v
            })
          })

        return arr
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/map/info/InfoToolDetails.vue